import { createSlice } from "@reduxjs/toolkit";
import { getAdahiSetting } from "../actions/adahi.actions";

const initialState = {
  ShowAdahi: false as boolean,
  error: null as unknown | null,
};

export const adahiSlice = createSlice({
  name: "adahi",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAdahiSetting.pending, (state) => {})
      .addCase(getAdahiSetting.fulfilled, (state, action) => {
        state.ShowAdahi = action.payload?.enable_adahi;
      })
      .addCase(getAdahiSetting.rejected, (state, action) => {
        state.ShowAdahi = false;
        state.error = action.payload;
      });
  },
});

export default adahiSlice.reducer;
